<template>
    <div class="columns">
        <div class="column is-half">
            
            <b-field label="Nombre de atributo">
                <b-input
                type="text"
                v-model="title"
                value=""
                maxlength="60"
                v-on:input="specialUpdate()">
                </b-input>
            </b-field>
        </div>
        <div class="column is-half">
            <b-field label="Valores">
            </b-field>
            <b-field class="p-0 m-0">
                <b-taginput
                    v-model="data.values"
                    class="p-0 m-0"
                    ellipsis
                    placeholder="Agregar un valor"
                    v-on:input="updateAttribute({index, data})">
                </b-taginput>
                <p class="control">
                    <a class="m-l-10 " @click="deleteAttribute(index)">
                        <b-icon size="is-small" class="has-text-danger" icon="times-circle" ></b-icon>
                    </a>
                </p>
            </b-field>
        </div>
    </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex"
export default {
    data(){
        return{
            title:""
        }
    },
    computed:{
        ...mapGetters(["getVariants"])
    },
    props:{
        index:{
            type:Number,
            default:0
        },
        data:{
            type:Object,
            default: new Object({})
        }
    },
    methods:{
        ...mapActions(['deleteAttribute', 'updateAttribute']),
        specialUpdate(){
            let oldTitle = this.data.title
            this.data.title = this.title.toLowerCase()
            this.getVariants.forEach(element => {
                try {
                    delete element[oldTitle]  
                }
                finally{

                }
            });
            this.updateAttribute({index:this.index, data:this.data})
        }
    }



}
</script>
